import { render } from "./ClinicHospitalizationHistory.vue?vue&type=template&id=5c680b68&scoped=true&ts=true"
import script from "./ClinicHospitalizationHistory.vue?vue&type=script&lang=ts"
export * from "./ClinicHospitalizationHistory.vue?vue&type=script&lang=ts"

import "./ClinicHospitalizationHistory.vue?vue&type=style&index=0&id=5c680b68&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c680b68"]])

export default __exports__